import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { formatCommonDate } from '../../../../utils/dateUtils';
import styles from './DateFooter.module.scss';

const cx = classNames.bind(styles);

export interface DateFooterProps {
  date: string | undefined;
  dataTestId?: string;
}

const DateFooter = ({ date, dataTestId }: DateFooterProps): ReactElement => {
  return (
    <div data-testid={dataTestId} className={cx('body')}>
      As of {formatCommonDate(date)}
    </div>
  );
};

export default DateFooter;
